import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as o } from "../../../../IconBase-CxZyIWw2.js";
const i = a((e, r) => /* @__PURE__ */ s.jsx(
  o,
  {
    ref: r,
    ...e,
    image: (t) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...t,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_4110",
              width: 7,
              height: 32,
              x: 21,
              y: 8,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M24.32 14.64c1.83 0 3.32-1.49 3.32-3.32S26.15 8 24.32 8 21 9.49 21 11.32s1.49 3.32 3.32 3.32m0-5.14c1 0 1.82.82 1.82 1.82s-.82 1.82-1.82 1.82-1.82-.82-1.82-1.82.82-1.82 1.82-1.82M24.32 20.68C22.49 20.68 21 22.17 21 24s1.49 3.32 3.32 3.32 3.32-1.49 3.32-3.32-1.49-3.32-3.32-3.32m0 5.14c-1 0-1.82-.82-1.82-1.82s.82-1.82 1.82-1.82 1.82.82 1.82 1.82-.82 1.82-1.82 1.82M24.32 33.36c-1.83 0-3.32 1.49-3.32 3.32S22.49 40 24.32 40s3.32-1.49 3.32-3.32-1.49-3.32-3.32-3.32m0 5.14c-1 0-1.82-.82-1.82-1.82s.82-1.82 1.82-1.82 1.82.82 1.82 1.82-.82 1.82-1.82 1.82"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4110)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h48v48H0z" }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyOtherIcon";
export {
  i as AgencyOtherIcon,
  i as default
};
//# sourceMappingURL=index.js.map
